import type { PoiLocationState } from '@/shared/api/types/poi-types'
import type { ITenantDestination } from '@/entities/tenant-destination'
import { useTranslation } from 'react-i18next'
import { PoiMapPicker } from '@/features/poi/poi-map-picker'
import { cn } from '@/shared/libs/cn'
import { FormSectionCard } from '@/shared/ui/form-section-card'
import { SectionSaveButton } from '@/shared/ui/section-save-button'

interface LocationCardProps {
  isEdit: boolean
  isFormReady: boolean
  location: PoiLocationState
  onChange: (value: PoiLocationState) => void
  /** Destination the map frames and keeps the POI inside of. */
  destination: ITenantDestination | undefined
  destinationCenter: { latitude: number; longitude: number } | null
  isDirty: boolean
  isSaving: boolean
  isSaveBlocked: boolean
  onSave: () => void
}

/** Map picker for the POI position, trigger radius and address. */
export function LocationCard({
  isEdit,
  isFormReady,
  location,
  onChange,
  destination,
  destinationCenter,
  isDirty,
  isSaving,
  isSaveBlocked,
  onSave,
}: LocationCardProps) {
  const { t } = useTranslation()

  return (
    <FormSectionCard
      title={t('poi.location')}
      action={
        isEdit && (
          <SectionSaveButton
            disabled={isSaveBlocked || !isDirty}
            saving={isSaving}
            onSave={onSave}
          />
        )
      }
    >
      <div className={cn(!isFormReady && 'opacity-50 pointer-events-none')}>
        <PoiMapPicker
          value={location}
          onChange={onChange}
          destinationAreaBoundary={destination?.areaBoundary ?? null}
          destinationCenter={destinationCenter}
        />
      </div>
    </FormSectionCard>
  )
}
